import React, { useMemo } from "react";

import { UnsavedChangesModal } from "../../../../components/modals/UnsavedChangesModal/unsaved-changes-modal.component";
import { UnderNdaBanner } from "../../../../features/common-attributes/components/under-nda-banner/under-nda-banner.component";
import { Tabs } from "../../../../components/layout/tabs/components/tabs/tabs.component";

import { getExecutionBriefTemplateView } from "../../types/execution-brief-template.functions";

import { ExecutionBriefWorkOrderTab } from "../execution-brief-work-order-tab/execution-brief-work-order-tab.component";
import { ExecutionApprovalTab } from "../execution-brief-approval-tab/execution-brief-approval-tab.component";
import { ExecutionBriefCommentsTab } from "../execution-brief-comments-tab/execution-brief-comments-tab.component";

import { ExecutionBriefFormProps } from "./execution-brief-form.props";

export const ExecutionBriefForm = (props: ExecutionBriefFormProps) => {
  const { forceOpen = false, headerHeight = 0, isDirty = false, template } = props;

  const TemplateView = useMemo(() => (template ? getExecutionBriefTemplateView(template) : null), [
    template,
  ]);

  if (!TemplateView) {
    return null;
  }

  const { isUnderNda, underNdaUserDetails } = props.ndaData;
  const tabPageTitles = ["Overview", "Brief Work Orders", "Approvals", "Comments"];

  const tabs: { title: string; contents: any }[] = [
    {
      title: tabPageTitles[0],
      contents: (
        <>
          <UnsavedChangesModal forceOpen={forceOpen} when={isDirty} />
          <UnderNdaBanner
            showIf={Boolean(props.ndaData.isUnderNda)}
            underNdaUserDetails={props.ndaData.underNdaUserDetails}
          />
          <TemplateView
            form={props.form}
            resourceId={props.resourceId}
            resourceType={template}
            userPermissions={props.userPermissions}
          />
        </>
      ),
    },
    {
      title: tabPageTitles[1],
      contents: <ExecutionBriefWorkOrderTab pageTitle={tabPageTitles[1]} />,
    },
    {
      title: tabPageTitles[2],
      contents: <ExecutionApprovalTab status={props.status} pageTitle={tabPageTitles[2]} />,
    },
    {
      title: tabPageTitles[3],
      contents: <ExecutionBriefCommentsTab pageTitle={tabPageTitles[3]} />,
    },
  ];

  return (
    <Tabs
      currentTabValue={props.currentTabValue}
      shouldChangeTab={props.shouldChangeTab}
      handleTabChange={props.handleTabChange}
      headerHeight={headerHeight}
      isUnderNda={isUnderNda}
      tabs={tabs}
      underNdaUserDetails={underNdaUserDetails}
    />
  );
};
